
<div class="about-section">
  <div class="container">
    <div class="row align-items-center m-1">
      <!-- Left Side: Text -->
      <div class="col-md-7 col-12 about-text">
        <h2>Our Programs</h2>
        <h3>Diverse Avenues for Discovery and Growth</h3>
        <p>
          Innovative Vision offers structured and organized co-curricular programs meticulously designed 
          to foster holistic growth in children, focusing on mind, body, and soul development. 
          Our methodology is progressive and outcome-based, with periodic assessments to monitor development.
        </p>
      </div>
      <!-- Right Side: Image -->
      <div class="col-md-5 col-12 text-center about-img">
        <img src="assets/ivimg/ourProgramH.svg" alt="Girl Learning Pottery" class="img-fluid">
      </div>
    </div>
  </div>
</div>
  
  <ul class="nav nav-pills mb-3 mt-3" id="pills-tab" role="tablist" >
    <li class="nav-item" role="presentation">
      <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill"
        data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
        aria-selected="true">Pre-Primary</button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill"
        data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile"
        aria-selected="false">Secondary</button>
    </li>
  </ul>
  <div class="tab-content" id="pills-tabContent">
    <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
      aria-labelledby="pills-home-tab">
<div class="programs-section">
  <div class="programs-grid">
    <!-- Card 1 -->
    <div class="program-card" routerLink="/programDetails" style="cursor: pointer;">
      <img src="assets/ivimg/sport.svg" alt="Sports Fitness (Fitkidz)"/>
      <h3>Sports Fitness (Fitkidz)</h3>
      <p>
        This program is designed to instill fundamental physical development, agility,
        and a strong foundation for overall well-being.
      </p>
    </div>
    <!-- Card 2 -->
    <div class="program-card" routerLink="/programDdance" style="cursor: pointer;">
      <img src="assets/ivimg/dance.svg" alt="Dance" />
      <h3>Dance</h3>
      <p>
        Our dance program introduces children to rhythm, movement, and creative expression
        in a joyful environment.
      </p>
    </div>
    <!-- Card 3 -->
    <div class="program-card" routerLink="/programDteakwondo" style="cursor: pointer;">
      <img src="assets/ivimg/thaikando.svg" alt="Taekwondo"/>
      <h3>Taekwondo</h3>
      <p>
        Taekwondo at Innovative Vision goes beyond physical training; it cultivates
        discipline, focus, and resilience.
      </p>
    </div>
    <div class="program-card" routerLink="/programDmusic" style="cursor: pointer;">
      <img src="assets/ivimg/music.svg" alt="Sports (Fitkidz)"/>
      <h3>Music</h3>
      <p>
        This programstimulates auditory senses and cognitive development. It helps children develo...
      </p>
    </div>
    <!-- Card 2 -->
    <div class="program-card" routerLink="/programDgymnastics" style="cursor: pointer;">
      <img src="assets/ivimg/gymnastics.svg" alt="Dance" />
      <h3>Gymnastics</h3>
      <p>
        Gymnastics is a physical activity that focuses on improving flexibility, coordination & body contro...
      </p>
    </div>
    <!-- Card 3 -->
    <div class="program-card" routerLink="/programDyoga" style="cursor: pointer;">
      <img src="assets/ivimg/I6.svg" alt="Taekwondo"/>
      <h3>Yoga</h3>
      <p>
        Yoga is a practice that is deeply integrated into the curriculum to address the mind and soul as...
      </p>
    </div>
    <div class="program-card" routerLink="/programDdramatic" style="cursor: pointer;">
      <img src="assets/ivimg/I7.svg" alt="Sports Fitness (Fitkidz)"/>
      <h3>Dramatics</h3>
      <p>
        Dramatics is a program that develops essential life skills through imaginative play & performan...
      </p>
    </div>
    <!-- Card 2 -->
    <div class="program-card" routerLink="/programDpottery" style="cursor: pointer;">
      <img src="assets/ivimg/programDetails/test.png" alt="Dance" />
      <h3>Pottery</h3>
      <p>
        Pottery is a hands-on activity that fosters creativity & develops fine motor skills. It allows.
      </p>
    </div>
    <!-- Card 3 -->
    <!-- <div class="program-card" routerLink="/programDetails">
      <img src="assets/ivimg/coreProgram3.svg" alt="Taekwondo"/>
      <h3>Taekwondo</h3>
      <p>
        Taekwondo at Innovative Vision goes beyond physical training; it cultivates
        discipline, focus, and resilience.
      </p>
    </div> -->
  </div>
  </div>
</div>
    <div class="tab-pane fade" id="pills-profile" role="tabpanel"
      aria-labelledby="pills-profile-tab">Content for Secondary...</div>
  </div>
  


